export default {"src":"/_next/static/media/light_flight.4d18214c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};